import {
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, Message, MessageService, PrimeIcons } from "primeng/api";
import { debounceTime, distinctUntilChanged, of, Subject, switchMap, Observable } from "rxjs";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ComuneDTO } from "src/app/models/comune.model";
import { SegnalazioniService } from "src/app/services/segnalazioni.service";
import { UtentiService } from "src/app/services/utenti.service";
import { Segnalazione } from "src/app/models/segnalazione.model";
import { UserService } from "src/app/services/user.service";
import { AreeCompetenzaService } from "src/app/services/areeCompetenza.service";
import { TipiInterventoService } from "src/app/services/tipiIntervento.service";
import { TipiSegnalazioneService } from "src/app/services/tipiSegnalazione.service";

import { Evento } from "src/app/models/evento.model";
import { EventiService } from "src/app/services/eventi.service";
import { CategoriaEvento } from "src/app/models/categoria.evento.model";
import { CategorieEventiService } from "src/app/services/categorieEventi.service";
import { Utente } from "src/app/models/utente.model";
import { TipoIntervento } from "src/app/models/tipoIntervento.model";

import { InterventiService } from "src/app/services/interventi.service";
import {AreaCompetenza} from "../../../models/areaCompetenza.model";

@Component({
  selector: "crea-evento",
  templateUrl: './crea-evento.component.html',
  styleUrls: ['../agenda.component.css']
})
export class CreaEventoComponent implements OnInit, OnDestroy {

  protected _onDestroy = new Subject<void>();

  protected creaEventoForm: FormGroup;
  protected pagineCreaEvento: MenuItem[];
  protected activeIndex: number = 0;


  protected ref: DynamicDialogRef;

  protected isSegnalatore:Boolean = false;

  protected idTecnico:string;
  protected dataInizioEvento:Date;
  protected dataFineEvento:Date;
  protected categorie:CategoriaEvento[]=[];
  protected isEventoForIntervento:Boolean= false;
  protected isLoadingSegnalazioni:Boolean= false;
  protected isLoadingCompetenze: Boolean = false;
  protected isLoadingTecnici:Boolean= false;
  protected isLoadingTipiIntervento:Boolean= false;
  protected isLoadingOperatori: boolean = false;

  protected showAccompagnatore:Boolean= false;
  protected showRiferimento: boolean = false;

  protected segnalazioni:Segnalazione[]=[];
  protected tecnici:Utente[]=[];
  protected operatori: Utente[] = [];

  protected tipiIntervento:TipoIntervento[]=[];
  protected accompagnatori: Utente[] = [];

  protected competenze: AreaCompetenza[];

  public utentiGiustificativo: Utente[];
  isLoadingUtenti: boolean;



  @HostBinding("class.mobile") isMobile: boolean;
  constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private _formBuilder: FormBuilder,
      private eventiService: EventiService,
      public dialogService: DialogService,
       private messageService: MessageService,
      protected userService:UserService,
      protected areeCompetenzaService:AreeCompetenzaService,
      protected tipiSegnalazioneService:TipiSegnalazioneService,
      private categoriaEventoService:CategorieEventiService,
      private segnalazioniService:SegnalazioniService,
      private utentiService:UtentiService,
      protected tipiInterventoService:TipiInterventoService,
      protected interventiService:InterventiService,

    ) {
      this.detectDevice();
      this.idTecnico        = this.config.data.risorsa;
      this.dataInizioEvento = this.config.data.dataInizio;
      this.dataFineEvento   = this.config.data.dataFine;
      // this.logger.info(this.dataInizioEvento + " vS " + this.dataFineEvento);


  }

  detectDevice() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    this.isMobile = isMobile;
  }
  ngOnDestroy(): void {

  }

  ngOnInit(): void {

    this.loadCategorieEventi();
    this.loadTecniciDisponibili();
    this.loadOperatoriRiferimento();
    this.loadAreeCompetenza();
    this.loadAccompagnatoriGiustificativo();
    this.creaEventoForm = this._formBuilder.group({
      operatoreRiferimento:   new FormControl({value: this.userService.getUser(), disabled: false}),
      categoria:              new FormControl({value: null, disabled: true}, Validators.required),
      segnalazione:           new FormControl({value: null, disabled: true}),
      tipoIntervento:           new FormControl({value: null, disabled: true}),
      note:                   [null],
      inizio:                 [this.dataInizioEvento],
      fine:                   [this.dataFineEvento],
      tecnico:                [this.idTecnico],
      accompagnatori:         new FormControl({value: null, disabled: false}),
      competenza:             new FormControl({value: null, disabled: false})
    });
  }

  loadAreeCompetenza () {
    this.isLoadingCompetenze = true;
    this.areeCompetenzaService.get().subscribe((data) => {
      console.log("aree competenza", data);
      this.competenze = data;
      this.isLoadingCompetenze = false;
    });

  }

  loadCategorieEventi(){
    this.categoriaEventoService.get().subscribe(categorieFromDb=>{
      //this.categorie = categorieFromDb;
      this.categorie = categorieFromDb.filter(categoria => categoria.label !== 'INTERVENTO');

      this.creaEventoForm.get('categoria')?.enable();

    });
  }

  loadTipiIntervento(){
    // this.logger.info(this.creaEventoForm.get("segnalazione").value);
    this.tipiInterventoService.getByLabelAreaCompetenza(this.creaEventoForm.get("segnalazione").value.tipoSegnalazione.areaCompetenza.label).subscribe(tipiInterventoFromDB =>{
      this.tipiIntervento = tipiInterventoFromDB;
      this.isLoadingTipiIntervento = false;
      this.creaEventoForm.get('tipoIntervento')?.enable();
    });
}

  loadSegnalazioni(){
    this.isLoadingSegnalazioni = true;
    this.segnalazioniService.getPianificabili().subscribe(segnalazioniPianificabili =>{
      this.segnalazioni = segnalazioniPianificabili;
      this.creaEventoForm.get('segnalazione')?.enable();
      this.isLoadingSegnalazioni = false;
    });
  }

  loadTecniciDisponibili(){
    this.isLoadingTecnici = true;
    this.utentiService.getTecnici().subscribe(tecniciFromDB=>{
      this.tecnici = tecniciFromDB.filter(tecnico => tecnico.id != this.idTecnico);
      this.creaEventoForm.get('tecnico')?.enable();
      this.creaEventoForm.get('accompagnatore')?.enable();
      this.isLoadingTecnici = false;
    });
  }

  loadOperatoriRiferimento() {
    this.isLoadingOperatori = true;
    this.utentiService.getOperatori().subscribe((operatori) => {
      this.operatori = [...operatori];
      this.isLoadingOperatori = false;
    });
  }

  onCategoriaEventoSelect(event:any){
     if(this.creaEventoForm.get("categoria").value.label==='INTERVENTO'){
        this.isEventoForIntervento = true;
        this.showAccompagnatore = true;
        this.showRiferimento = false;
        this.loadSegnalazioni();
      }else{
        this.isEventoForIntervento = false;
        if(this.creaEventoForm.get("categoria").value.label==='MANUTENZIONE'){
          this.showAccompagnatore = true;
          this.showRiferimento = true;
        }else{
          this.showAccompagnatore = this.creaEventoForm.get("categoria").value.label==='GIUSTIFICATIVO';
          this.showRiferimento = false;
        }
      }
  }
  onSegnalazioneSelect(event:any){
    this.isLoadingTipiIntervento = true;
    this.loadTipiIntervento();

  }

  loadAccompagnatoriGiustificativo () {
    this.isLoadingUtenti = true;
    this.utentiService.get().subscribe((data: Utente[]) => {
      this.utentiGiustificativo = data.filter((item) => {
        return `${item.id}` != this.idTecnico;
      }).sort((itemA, itemB) => {
        return itemA.nome.localeCompare(itemB.nome);
      });
      this.isLoadingUtenti = false;
    });
  }



  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {

        let eventoUtente:Evento = new Evento();
        let operatoreRiferimento:Utente = this.userService.getUser();
        operatoreRiferimento = this.creaEventoForm.get("operatoreRiferimento").value;

        eventoUtente.operatoreRiferimento   = operatoreRiferimento;
        eventoUtente.categoria   = this.creaEventoForm.get("categoria").value;
        eventoUtente.note                  = this.creaEventoForm.get("note").value;
        eventoUtente.inizio                = this.creaEventoForm.get("inizio").value;
        eventoUtente.fine                  = this.creaEventoForm.get("fine").value;
        eventoUtente.accompagnatori         = this.creaEventoForm.get("accompagnatori").value?.map((utente: Utente)=> {
          return utente.id;
        }) ?? null;

        const competenza_form =  this.creaEventoForm.get("competenza").value?.id ?? null;
        console.log("categoria", eventoUtente.categoria.id,"competenza", competenza_form);
        if (eventoUtente.categoria.id == 2 && competenza_form != null) {
          eventoUtente.areaCompetenza = {id: this.creaEventoForm.get("competenza").value["id"]};
        }

        if(this.creaEventoForm.get("tecnico").value){
          let tecnico:Utente = new Utente();
          tecnico.id = Number(this.idTecnico);
          eventoUtente.utente = tecnico;
        }

        if(this.creaEventoForm.get("accompagnatori").value) {
          eventoUtente.accompagnatori = this.creaEventoForm.get("accompagnatori").value.map((utente: Utente) => {
            return {id: utente.id};
          });
        }

        this.eventiService.crea(eventoUtente).subscribe(eventoCreato => {
          this.dialogRef.close({
            success: true
          });
        },
        error => {
          console.error('ERRORE CREAZIONE EVENTO' + error);
          this.dialogRef.close({
            success: false
          });
        });



    }
  }


}
